import { Chakra } from "@airhelp/react-ui-components";
import StickyBottomBarTrigger from "components/StickyBottomBar/StickyBottomBarTrigger";
import Grid from "../Grid";
import Links from "./Links";
import TrustSection from "./TrustSection";

const { Box, Flex } = Chakra;

const FooterSimple = () => (
  <StickyBottomBarTrigger type="second">
    <Box bg="greyscale.300">
      <Grid mb={0}>
        <Flex flexDir="column" gridColumn={{ base: "span 1", md: "span 12" }}>
          <TrustSection />
          <Links />
        </Flex>
      </Grid>
    </Box>
  </StickyBottomBarTrigger>
);

export default FooterSimple;
